import React, { useState, useEffect,useRef } from 'react'
import { Link } from 'react-router-dom'
import { useParams, useLoaderData } from 'react-router-dom';
import '../layout/GamaProdutos.Module.css'
import { cardImageSlide as gamaCategorias } from '../card-slide';
import { useLanguage } from './LanguageContext';
import {addToRecentView } from './ProdDetail';
import { useTranslation } from 'react-i18next';
import {colors } from '../colors';
import { useLocation, useNavigate } from "react-router-dom";
import ProductCard from './ProductCard'
import { ourBrands, reBrands } from '../brands'
import Slider from 'react-slick'

function GamaProdutos() {
  let {name} = useParams();
  const { selectedLanguage } = useLanguage();
  const { t,i18n } = useTranslation();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const gama = gamaCategorias.find((n)=>Object.values(n.bigtitle).includes(name));
  const [produtos, setProdutos] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [filtered, setFiltered] = useState([]);  
  const [selectedIps, setSelectedIps] = useState([]);
  const [selectedIks, setSelectedIks] = useState([]);
  const [selectedMarcas, setSelectedMarcas] = useState([]);
  const [selectedCores, setSelectedCores] = useState([]);
  const [selectedPowers, setSelectedPowers] = useState([]);
  const idGama = gama?.id; // valor fixo do banco
  const pagesToShow = 3; // número de páginas visíveis ao redor da página atual
  const halfPages = Math.floor(pagesToShow / 2); 
  const [loading, setLoading] = useState(false); 
  let startPage = Math.max(currentPage - halfPages, 1);
  let endPage = Math.min(currentPage + halfPages, totalPages);

  const outrasGamas = gamaCategorias.filter((n) => n.id !== idGama);

  if (endPage - startPage < pagesToShow - 1) {
    startPage = Math.max(endPage - pagesToShow + 1, 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);


const fetchProdutos = () => {
  if (!idGama) return;

   setLoading(true);

  const queryParams = new URLSearchParams({
    gama: idGama,
    page: currentPage,
    limit: 24
  });

  if (selectedIps.length) queryParams.append('ips', selectedIps.map(ip => ip.trim()).join(','));
  if (selectedIks.length) queryParams.append('iks', selectedIks.join(','));
  if (selectedMarcas.length) queryParams.append('marcas', selectedMarcas.join(','));
  if (selectedCores.length) queryParams.append('cores', selectedCores.join(','));
  if (selectedPowers.length) {
  queryParams.set('power', selectedPowers.join(',')); // envia "0-5W,11-20W"
} else {
  queryParams.delete('power');
}

  const request = fetch(`https://advancelighting.pt/gamaprodutos-filtrados.php?${queryParams.toString()}`)
    .then(res => res.json());

  const delay = new Promise(resolve => setTimeout(resolve, 400)); // mínimo de 400ms

  Promise.all([request, delay])
    .then(([data]) => {
      setProdutos(data.produtos || []);
      setTotalResults(data.totalResults || 0);
      setTotalPages(data.totalPages || 1);
      setCurrentPage(data.currentPage || 1);
    })
    .catch(err => {
      console.error("Erro ao carregar produtos:", err);
      setProdutos([]);
      setTotalResults(0);
    }).finally(() => {
      setLoading(false); // <- desliga skeleton
    });;
};

useEffect(() => {
  fetchProdutos();
}, [idGama, currentPage, selectedIps, selectedIks, selectedMarcas, selectedCores, selectedPowers]);

const handlePageChange = (page) => {
  setLoading(true);

  // Simulando um "delay" para dar tempo de mostrar o skeleton
  setTimeout(() => {
    setCurrentPage(page);
    setLoading(false);
  }, 500); // meio segundo (pode ajustar)
};

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", currentPage);
    navigate(`?${params.toString()}`, { replace: true });
  }, [currentPage]);

const startItem = (currentPage - 1) * 24 + 1;
const endItem = Math.min(currentPage * 24, totalResults);

useEffect(() => {
  let result = [...produtos];

  if (selectedIps.length > 0) {
    result = result.filter(p => selectedIps.includes(p.ip));
  }

  if (selectedIks.length > 0) {
    result = result.filter(p => selectedIks.includes(p.ik));
  }

  setFiltered(result);
}, [selectedIps, selectedIks, produtos]);

  const predefinedIps = [
    { ip: '20' },
    { ip: '33' },
    { ip: '40' },
    { ip: '42' },
    { ip: '44' },
    { ip: '54' },
    { ip: '55' },
    { ip: '65' },
    { ip: '66' },
    { ip: '67' },
    { ip: '68' },
    { ip: '69K'},
  ];
const [listIps, setListIps] = useState(predefinedIps);

const predefinedIks = [
  { ik: '04' },
  { ik: '06' },
  { ik: '07' },
  { ik: '08' },
  { ik: '10' },
];

  const powerRanges = [
    { label: "0-5W", min: 0, max: 5 },
    { label: "6-10W", min: 6, max: 10 },
    { label: "11-20W", min: 11, max: 20 },
    { label: "21-50W", min: 21, max: 50 },
    { label: "51W+", min: 51, max: Infinity },
  ];
    
const handleFilterChange = (filterType, value) => {
  setCurrentPage(1); // volta para a primeira página
  switch(filterType) {
    case 'ip':
      setSelectedIps(prev => prev.includes(value) ? prev.filter(x=>x!==value) : [...prev,value]);
      break;
    case 'ik':
      setSelectedIks(prev => prev.includes(value) ? prev.filter(x=>x!==value) : [...prev,value]);
      break;
    case 'marca':
      setSelectedMarcas(prev => prev.includes(value) ? prev.filter(x=>x!==value) : [...prev,value]);
      break;
    case 'cor':
      setSelectedCores(prev => prev.includes(value) ? prev.filter(x=>x!==value) : [...prev,value]);
      break;
    case 'power':
      setSelectedPowers(prev => prev.includes(value) ? prev.filter(x => x !== value) : [...prev, value]);
      break;
  }
};

const productsRef = useRef(null);
useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}, [currentPage]);

  return (
     <div id='gama'>
       <div className='top-banner'>
        <img src={gama.banner} alt={gama.bigtitle?.[i18n.language]} className="banner-img" />
        <h1 className='banner-title'>{gama.bigtitle?.[i18n.language]}</h1>
     </div>

    <div className="container-xxl mx-auto m-5">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb"> 
            <li className="breadcrumb-item"><a className="text-decoration-none text-uppercase" href="/produtos">{t('homepage.produtos')}</a></li>
            <li className="breadcrumb-item active text-uppercase" aria-current="page"></li>
          </ol>
        </nav>

        <div className="row">
             <div className="col-12 col-md-3 col-xl-2 prod-list-filter-wrapper offcanvas offcanvas-start" tabIndex={-1} id="prodFilters" aria-labelledby="prodFilters">
            <div className="offcanvas-header d-lg-none pe-0">
              <button className="btn ms-auto px-3" type="button" data-bs-dismiss="offcanvas" aria-label="Close"><i className="fa-solid fa-backward" /></button>
            </div>
          <div className="offcanvas-body p-3 pt-2 pb-3 scroll-right">        
            <div className="filter-block">
              <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterMarcas" aria-expanded="false" aria-controls="filterMarcas">{t('navbar.marcas')}</button>
                <div className="prod-list-filter-list collapse show" id="filterMarcas">
                    <div className="custom-scroll">
                      {ourBrands.map((item,index)=>(
                          <label className="material-checkbox text-uppercase" key={index}>
                          <input type="checkbox" id={item.name} name={item.name} value={item.name} onChange={() => handleFilterChange('marca', item.name)}/>
                          <span className="checkmark"></span>
                          {item.name}
                          </label>
                      ))} 
      
                      {reBrands.map((item,index)=>(
                          <label className="material-checkbox text-uppercase" key={index}>
                          <input type="checkbox" id={item.name} name={item.name} value={item.name} onChange={() => handleFilterChange('marca', item.name)}/>
                          <span className="checkmark"></span>
                          {item.name}
                          </label>
                      ))} 
                    </div>
                </div>

              <hr className="card-line w-100" />
              <div className="filter-block">
                <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterW" aria-expanded="false" aria-controls="filterW">{t('pdetail.potencia')}(W)</button>
                  <div className="prod-list-filter-list collapse" id="filterW">
                  <div className="custom-scroll">
                  {powerRanges.map((range, index) => (
                      <label className="material-checkbox" key={index}>
                        <input type="checkbox" value={range.label}  checked={selectedPowers.includes(range.label)} onChange={() => handleFilterChange('power', range.label)}/>
                        <span className="checkmark"></span> {range.label}
                      </label>
                    ))}
                  </div>
                  </div>
                </div>

                <hr className="card-line w-100" />
                <div className="filter-block">
                  <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterIp" aria-expanded="false" aria-controls="filterIp">IP</button>
                  <div className="prod-list-filter-list collapse" id="filterIp">
                    <div className="custom-scroll">
                    {listIps.map((item,index)=>(
                      <label className="material-checkbox" key={index}>
                      <input type="checkbox" id={item.ip} value={item.ip.toString()} onChange={() => handleFilterChange('ip', item.ip)}/>
                      <span className="checkmark"></span> {item.ip}
                    </label> ))}
                    </div>
                  </div>
                </div>

            <hr className="card-line w-100" />
            <div className="filter-block">
                <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filterIk" aria-expanded="false" aria-controls="filterIk">IK</button>
                <div className="prod-list-filter-list collapse" id="filterIk">
                  <div className="custom-scroll">
                  {predefinedIks.map((item,index)=>(
                    <label className="material-checkbox" key={index}>
                    <input type="checkbox" id={item.ik} value={item.ik.toString()} onChange={() => handleFilterChange('ik', item.ik)}/>
                    <span className="checkmark"></span>
                    {item.ik}
                  </label>
                    ))}
                  </div>
                </div>
            </div>

            <hr className="card-line w-100" />
            <div className="filter-block">
                <button className="filter-title headline collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#filtercor" aria-expanded="false" aria-controls="filtercor">{t('pdetail.cor')}</button>
              <div className="prod-list-filter-list collapse" id="filtercor">
                  <div className="custom-scroll colorList">
                {colors.map((item, index) => (
                  <label className="material-checkbox filter-field" key={index}>
                    <input type="checkbox" value={item.nome} onChange={() => handleFilterChange('cor', item.cor)}  />
                    <span className="checkmark"></span>
                    {item.nome[selectedLanguage]}
                  </label>
                  ))}
                  </div>
              </div>
            </div>
            </div>
            </div>
             </div>
              <div className="col-12 col-md prod-list-content-wrapper scroll-bottom">
              <div className="row g-4 prod-list-wrapper position-relative" id="prod-list">
              <span className='total-prods' > {t('listProds.existem')} <b>{startItem}</b> - <b>{endItem}</b> {t('homepage.de')} <b>{totalResults}</b> {t('homepage.produtos')}</span>
                  {loading ? (
                    // skeletons de produto (placeholder)
                    Array.from({ length: 8 }).map((_, i) => (
                      <div key={i} className="col-sm-6 col-lg-3 col-md-3 col-6 product-card">
                        <div className="skeleton h-48 w-full mb-2"></div>
                        <div className="skeleton h-4 w-3/4 mb-1"></div>
                        <div className="skeleton h-4 w-1/2"></div>
                      </div>
                    ))
                  ) : produtos.length === 0 ? (
                    <p>{t('homepage.nenhumProd')}</p>
                  ) : (
                  filtered.map((p, index) => (
                    <div className="col-sm-6 col-lg-3 col-md-3 col-6 product-card" key={p.idP || index}>
                      <ProductCard resu={p} t={t} addToRecentView={addToRecentView}/>
                    </div>
                  ))
                )}
              </div>
            </div> 
          <div className='center-pagination'>
            <section className="pagination-section p-5 bd-highlight mb-3">
            <ul className="pagination-prods">
            <li>
            <button id="pg-button-prev" type="button" className="pagination__button" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
              <i className="fa fa-chevron-left" />
            </button>
            </li>

              {startPage > 1 && (
                <>
                  <li><button onClick={() => setCurrentPage(1)}>1</button></li>
                  {startPage > 2 && <span className='pagination__button_ellipses'>...</span>}
                </>
              )}

              {/* páginas do meio */}
              {pageNumbers.map((p) => (
                <li key={p} className={p === currentPage ? 'active' : ''}>
                  <button onClick={() => setCurrentPage(p)}>{p}</button>
                </li>
              ))}

              {/* última página + "..." se necessário */}
              {endPage < totalPages && (
                <>
                  {endPage < totalPages - 1 && <span className='pagination__button_ellipses'>...</span>}
                  <li><button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button></li>
                </>
              )}
            <li>
            <button id="pg-button-next" type="button" className="pagination__button" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
              <i className="fa fa-chevron-right" />
            </button>
            </li>
            </ul>
          </section>
        </div>
        <div className='otherRanges'>
          <h2 className='text'>{t('homepage.maisGamas')}</h2>
          <div id="OtherRanges" className="gallery">
          {outrasGamas.map((item, index) => (
              <Link key={index} to={`/${item.bigtitle?.[i18n.language]}`} className={`gallery__item gallery__item--${index+1}`}>
                 <img src={item.linkImg} alt={item.nomeOriginal} className='gallery__img'/>
                 <h5 className="gallery_name">{item.bigtitle?.[i18n.language]}</h5>
                <span className="news-card__read-more">
                {t('homepage.verMais')}<i className="fas fa-long-arrow-alt-right"></i>
                </span>
              </Link>
          ))}
        </div>
        </div>

        </div>
    </div> 
    </div>
  )
}

export default GamaProdutos